import {RefObject, useEffect} from 'react';

/**
 * Sets `--app-shelf-bleed-left/right` on the root so shelf rails and the tab row can span the
 * page edge to edge while headings stay in the centered column.
 */
export const useShelfBleed = (rootRef: RefObject<HTMLElement>) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    // Distances from the column to the page's edges: #main's left (past the nav) and the
    // viewport's right (clientWidth excludes the scrollbar).
    const updateBleed = () => {
      const rect = root.getBoundingClientRect();
      const pageLeft = root.closest('#main')?.getBoundingClientRect().left ?? 0;
      const left = Math.max(rect.left - pageLeft, 0);
      const right = Math.max(document.documentElement.clientWidth - rect.right, 0);
      root.style.setProperty('--app-shelf-bleed-left', `${left}px`);
      root.style.setProperty('--app-shelf-bleed-right', `${right}px`);
    };

    updateBleed();
    window.addEventListener('resize', updateBleed);
    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateBleed) : null;
    resizeObserver?.observe(root);
    return () => {
      window.removeEventListener('resize', updateBleed);
      resizeObserver?.disconnect();
    };
  }, [rootRef]);
};
